module.exports = __webpack_public_path__ + "media/images/donation/logo-mizuho-1f72bd0986da5b2ed595f81f78baf39f.jpg";